// @flow

import React, { Component } from 'react';
import { NavHashLink as NavLink } from 'react-router-hash-link';
import Menu from "../Menu"
import './RoofHeader.scss';

export default class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      menu: false,
      active: false
    };
  }

  showMenu(event) {
    console.log("showe menu", this.state.active);
    event.preventDefault();
    this.setState({
      active: true
    });
  }
  toggleMenu() {
    this.setState({
      active: !this.state.active
    });
  }

  closeMenu() {
    this.setState({
      active: false
    });
  }

  render() {
    return (
      <React.Fragment>
        <header>
          <div className="header container row">
            <div className="col-3 evomer">
              <img src="/img/evomer-logo.png"></img>
              <p className="text-evomer-red">Dwa razy szybsze</p>
              <p className="text-evomer-white">niż inne rozwiązania</p>
            </div>
            <div className="col-6 header-title">
              <h1 className="h1-red-big">2x szybsza</h1>
              <h2 className="h2-white">Renowacja dachu</h2>
              <h2 className="h2-red-bg">Nawet w jeden dzień</h2>
            </div>
            <div className="col-3 tytan">
              <img src="/img/tytan-logo.png"></img>
              <span className="af-icon-menu"></span>
            </div>
          </div>  
        </header>
        <Menu
            menu={this.state.active}
            closeMenu={this.closeMenu.bind(this)}
            activeLink={this.props.activeLink}
          />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RoofHeader/RoofHeader.js